import React, { Component } from 'react';
import Global from '../../../Global';
import './IchatWindow.css'
import ichatLogo from './../../../images/ichat/icon-ichat-logo.png';
import iconUser from './../../../images/ichat/icon-user.png';
import iconChatSend from './../../../images/ichat/icon-chat-send.png';

class IchatWindow extends Component {

  constructor(props) {
    super(props);
  }
  
  endChat(){
    document.getElementById("ichatWindow-div").style.display = "none";
  }
  
  sendMsg(){
    let nodeDiv = document.createElement("div");
    nodeDiv.className = 'send-msg-div';
    
    let nodeChildDiv = document.createElement("div");
    nodeChildDiv.className = 'send-msg';
    
    let msgContent = document.getElementById("msg-content");
    let nodeText = document.createTextNode(msgContent.value);
    nodeChildDiv.appendChild(nodeText);
    nodeDiv.appendChild(nodeChildDiv);
    
    let msgContentElement = document.getElementById("ichatWindow-center");
    msgContentElement.appendChild(nodeDiv); 
  }
  

  render() {
    var myStyle = "";
    if(this.props.visible){
      myStyle = {
        display: "block"
      }
    }else{
      myStyle = {
        display: "none"
      }
    }
    if(this.props.visible){
      document.getElementById("ichatWindow-div").style.display = "block";
    }
    
      return (
        <div id="ichatWindow-div" className="ichatWindow-div" style={ myStyle }>
          <div className="ichatWindow-top">
            <img className="ichatWindow-icon" src={ichatLogo}/>
            <div className="top-tools">
              <div className="top-tools-left">
                <img src={iconUser}/>
                LOGIN
              </div>
              <div className="top-tools-right">
                <div className="end-chat" onClick={()=>this.endChat()}>End Chat</div>
              </div>
            </div>
          </div>
          <div className="ichatWindow-center" id="ichatWindow-center">
            <div className="receive-msg-div"><div className="receive-msg">hello</div></div>
            <div className="send-msg-div"><div className="send-msg">hello,How are you?</div></div>
          </div>
          <div className="ichatWindow-footer">
            <input id="msg-content" placeholder="message here..."/>
            <img onClick={ ()=>this.sendMsg() }  src={iconChatSend}/>
          </div>
        </div>
      )
  }
}

export default IchatWindow;